/**
 * Color tokens (FRONTEND.md: theme owns the visual vocabulary, no
 * domain knowledge). Text wears ink; accents carry state and action
 * color; every component reads THESE, never a hex of its own.
 */

/** THE MARK'S OWN COLOUR, sampled from public/brand/polywog-mark.png
 * rather than eyeballed -- the logo is the source and everything else
 * matches it. Stated again as --brand-teal in index.css because CSS
 * cannot read this file; the two are one law in two media, like the
 * bucket names in naming.py and HCL. */
export const BRAND = {
  teal: '#00C0CD',
  /** 85% of the brand, for a pressed/hover state on raw CSS controls.
   * AntD derives its own from colorPrimary and needs nothing here. */
  tealHover: '#00A3AE',
} as const;

export const INK = {
  primary: '#e5e7eb',
  secondary: '#9ca3af',
  muted: '#6b7280',
  faint: '#374151',
} as const;

export const ACCENT = {
  blue: '#60a5fa',
  green: '#34d399',
  amber: '#fbbf24',
  red: '#ef4444',
} as const;

/** The categorical series palette, fixed order (validated 2026-08-06:
 * CVD + contrast pass on the dark surface — see the vault's
 * Ease-of-Use Audit). Consumers map their domains onto slots; a new
 * domain never mints a hue. */
export const CATEGORICAL = ['#f59e0b', '#3b82f6', '#10b981', '#a78bfa'] as const;

/** Redline paint (marked-failing area fills and pins): deliberately
 * lighter than ACCENT.red so alpha-ramped area washes stay readable
 * over the dark surface. */
export const REDLINE = '#f87171';


/** A translucent wash of an accent (chip/button backgrounds). */
export function tint(hex: string, alpha = 0.15): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
